import { render, staticRenderFns } from "./DYGoodPromote.vue?vue&type=template&id=651bee35&scoped=true"
import script from "./DYGoodPromote.vue?vue&type=script&lang=js"
export * from "./DYGoodPromote.vue?vue&type=script&lang=js"
import style0 from "./DYGoodPromote.vue?vue&type=style&index=0&id=651bee35&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651bee35",
  null
  
)

export default component.exports